import { forwardRef, type SelectHTMLAttributes } from 'react';

import { cx } from '../lib/cx';

export interface SelectOption {
  value: string;
  label: string;
  disabled?: boolean;
}

export interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  options: readonly SelectOption[];
  invalid?: boolean;
  /** Optional leading placeholder option. */
  placeholder?: string;
}

/** Native `<select>`, restyled. Native semantics = keyboard + a11y for free. */
export const Select = forwardRef<HTMLSelectElement, SelectProps>(function Select(
  { options, invalid, placeholder, className, ...rest },
  ref,
) {
  return (
    <select
      ref={ref}
      className={cx('ds-select', className)}
      aria-invalid={invalid === true ? true : undefined}
      {...rest}
    >
      {placeholder !== undefined ? (
        <option value="" disabled>
          {placeholder}
        </option>
      ) : null}
      {options.map((option) => (
        <option key={option.value} value={option.value} disabled={option.disabled}>
          {option.label}
        </option>
      ))}
    </select>
  );
});
